import { SUPPORTED_LANGUAGE } from './supportedLanguages';
import { TRANSLATION_NAMESPACE } from './translationNamespaces';

import englishCommon from './locales/en/common.json';
import englishAuth from './locales/en/auth.json';
import englishNavigation from './locales/en/navigation.json';
import englishCalendar from './locales/en/calendar.json';
import englishAppointments from './locales/en/appointments.json';
import englishDashboard from './locales/en/dashboard.json';
import englishSettings from './locales/en/settings.json';
import englishValidation from './locales/en/validation.json';
import englishErrors from './locales/en/errors.json';
import englishAdmin from './locales/en/admin.json';
import englishOnboarding from './locales/en/onboarding.json';
import englishModules from './locales/en/modules.json';
import englishClients from './locales/en/clients.json';
import englishClientImport from './locales/en/clientImport.json';
import englishPatients from './locales/en/patients.json';
import englishTreatmentLibrary from './locales/en/treatmentLibrary.json';
import englishServices from './locales/en/services.json';
import englishConsultations from './locales/en/consultations.json';
import englishIntake from './locales/en/intake.json';
import englishPlans from './locales/en/plans.json';
import englishFiles from './locales/en/files.json';
import englishFilePreview from './locales/en/filePreview.json';
import englishNotifications from './locales/en/notifications.json';
import englishProgress from './locales/en/progress.json';
import englishReports from './locales/en/reports.json';
import englishChat from './locales/en/chat.json';
import englishSupport from './locales/en/support.json';
import englishConsents from './locales/en/consents.json';
import englishTeam from './locales/en/team.json';
import englishBroadcasts from './locales/en/broadcasts.json';
import englishLegal from './locales/en/legal.json';
import englishActivity from './locales/en/activity.json';
import englishEmailLog from './locales/en/emailLog.json';
import englishCustomDomains from './locales/en/customDomains.json';
import englishWorkspaceData from './locales/en/workspaceData.json';
import englishAssistant from './locales/en/assistant.json';

import polishCommon from './locales/pl/common.json';
import polishAuth from './locales/pl/auth.json';
import polishNavigation from './locales/pl/navigation.json';
import polishCalendar from './locales/pl/calendar.json';
import polishAppointments from './locales/pl/appointments.json';
import polishDashboard from './locales/pl/dashboard.json';
import polishSettings from './locales/pl/settings.json';
import polishValidation from './locales/pl/validation.json';
import polishErrors from './locales/pl/errors.json';
import polishAdmin from './locales/pl/admin.json';
import polishOnboarding from './locales/pl/onboarding.json';
import polishModules from './locales/pl/modules.json';
import polishClients from './locales/pl/clients.json';
import polishClientImport from './locales/pl/clientImport.json';
import polishPatients from './locales/pl/patients.json';
import polishTreatmentLibrary from './locales/pl/treatmentLibrary.json';
import polishServices from './locales/pl/services.json';
import polishConsultations from './locales/pl/consultations.json';
import polishIntake from './locales/pl/intake.json';
import polishPlans from './locales/pl/plans.json';
import polishFiles from './locales/pl/files.json';
import polishFilePreview from './locales/pl/filePreview.json';
import polishNotifications from './locales/pl/notifications.json';
import polishProgress from './locales/pl/progress.json';
import polishReports from './locales/pl/reports.json';
import polishChat from './locales/pl/chat.json';
import polishSupport from './locales/pl/support.json';
import polishConsents from './locales/pl/consents.json';
import polishTeam from './locales/pl/team.json';
import polishBroadcasts from './locales/pl/broadcasts.json';
import polishLegal from './locales/pl/legal.json';
import polishActivity from './locales/pl/activity.json';
import polishEmailLog from './locales/pl/emailLog.json';
import polishCustomDomains from './locales/pl/customDomains.json';
import polishWorkspaceData from './locales/pl/workspaceData.json';
import polishAssistant from './locales/pl/assistant.json';

export const translationResources = {
  [SUPPORTED_LANGUAGE.english]: {
    [TRANSLATION_NAMESPACE.common]: englishCommon,
    [TRANSLATION_NAMESPACE.auth]: englishAuth,
    [TRANSLATION_NAMESPACE.navigation]: englishNavigation,
    [TRANSLATION_NAMESPACE.calendar]: englishCalendar,
    [TRANSLATION_NAMESPACE.appointments]: englishAppointments,
    [TRANSLATION_NAMESPACE.dashboard]: englishDashboard,
    [TRANSLATION_NAMESPACE.settings]: englishSettings,
    [TRANSLATION_NAMESPACE.validation]: englishValidation,
    [TRANSLATION_NAMESPACE.errors]: englishErrors,
    [TRANSLATION_NAMESPACE.admin]: englishAdmin,
    [TRANSLATION_NAMESPACE.onboarding]: englishOnboarding,
    [TRANSLATION_NAMESPACE.modules]: englishModules,
    [TRANSLATION_NAMESPACE.clients]: englishClients,
    [TRANSLATION_NAMESPACE.clientImport]: englishClientImport,
    [TRANSLATION_NAMESPACE.patients]: englishPatients,
    [TRANSLATION_NAMESPACE.treatmentLibrary]: englishTreatmentLibrary,
    [TRANSLATION_NAMESPACE.services]: englishServices,
    [TRANSLATION_NAMESPACE.consultations]: englishConsultations,
    [TRANSLATION_NAMESPACE.intake]: englishIntake,
    [TRANSLATION_NAMESPACE.plans]: englishPlans,
    [TRANSLATION_NAMESPACE.files]: englishFiles,
    [TRANSLATION_NAMESPACE.filePreview]: englishFilePreview,
    [TRANSLATION_NAMESPACE.notifications]: englishNotifications,
    [TRANSLATION_NAMESPACE.progress]: englishProgress,
    [TRANSLATION_NAMESPACE.reports]: englishReports,
    [TRANSLATION_NAMESPACE.chat]: englishChat,
    [TRANSLATION_NAMESPACE.support]: englishSupport,
    [TRANSLATION_NAMESPACE.consents]: englishConsents,
    [TRANSLATION_NAMESPACE.team]: englishTeam,
    [TRANSLATION_NAMESPACE.broadcasts]: englishBroadcasts,
    [TRANSLATION_NAMESPACE.legal]: englishLegal,
    [TRANSLATION_NAMESPACE.activity]: englishActivity,
    [TRANSLATION_NAMESPACE.emailLog]: englishEmailLog,
    [TRANSLATION_NAMESPACE.customDomains]: englishCustomDomains,
    [TRANSLATION_NAMESPACE.workspaceData]: englishWorkspaceData,
    [TRANSLATION_NAMESPACE.assistant]: englishAssistant,
  },
  [SUPPORTED_LANGUAGE.polish]: {
    [TRANSLATION_NAMESPACE.common]: polishCommon,
    [TRANSLATION_NAMESPACE.auth]: polishAuth,
    [TRANSLATION_NAMESPACE.navigation]: polishNavigation,
    [TRANSLATION_NAMESPACE.calendar]: polishCalendar,
    [TRANSLATION_NAMESPACE.appointments]: polishAppointments,
    [TRANSLATION_NAMESPACE.dashboard]: polishDashboard,
    [TRANSLATION_NAMESPACE.settings]: polishSettings,
    [TRANSLATION_NAMESPACE.validation]: polishValidation,
    [TRANSLATION_NAMESPACE.errors]: polishErrors,
    [TRANSLATION_NAMESPACE.admin]: polishAdmin,
    [TRANSLATION_NAMESPACE.onboarding]: polishOnboarding,
    [TRANSLATION_NAMESPACE.modules]: polishModules,
    [TRANSLATION_NAMESPACE.clients]: polishClients,
    [TRANSLATION_NAMESPACE.clientImport]: polishClientImport,
    [TRANSLATION_NAMESPACE.patients]: polishPatients,
    [TRANSLATION_NAMESPACE.treatmentLibrary]: polishTreatmentLibrary,
    [TRANSLATION_NAMESPACE.services]: polishServices,
    [TRANSLATION_NAMESPACE.consultations]: polishConsultations,
    [TRANSLATION_NAMESPACE.intake]: polishIntake,
    [TRANSLATION_NAMESPACE.plans]: polishPlans,
    [TRANSLATION_NAMESPACE.files]: polishFiles,
    [TRANSLATION_NAMESPACE.filePreview]: polishFilePreview,
    [TRANSLATION_NAMESPACE.notifications]: polishNotifications,
    [TRANSLATION_NAMESPACE.progress]: polishProgress,
    [TRANSLATION_NAMESPACE.reports]: polishReports,
    [TRANSLATION_NAMESPACE.chat]: polishChat,
    [TRANSLATION_NAMESPACE.support]: polishSupport,
    [TRANSLATION_NAMESPACE.consents]: polishConsents,
    [TRANSLATION_NAMESPACE.team]: polishTeam,
    [TRANSLATION_NAMESPACE.broadcasts]: polishBroadcasts,
    [TRANSLATION_NAMESPACE.legal]: polishLegal,
    [TRANSLATION_NAMESPACE.activity]: polishActivity,
    [TRANSLATION_NAMESPACE.emailLog]: polishEmailLog,
    [TRANSLATION_NAMESPACE.customDomains]: polishCustomDomains,
    [TRANSLATION_NAMESPACE.workspaceData]: polishWorkspaceData,
    [TRANSLATION_NAMESPACE.assistant]: polishAssistant,
  },
} as const;
